
import userCountryMixin from '@/mixins/userCountryMixin'

export default {
  name: 'EstimatedDeliveryDate',
  mixins: [userCountryMixin],
  props: {
    show_stock: {
      type: Boolean,
      default: true,
    },
    show_informations_button: {
      type: Boolean,
      default: true,
    },
    fastest_shipping_method_range: {
      type: Object,
      required: true,
    },
  },
}
